export const menuItems = [
    {
      title: 'ホーム',
      url: '/',
    },
    {
      title: 'アニメ化シリーズ',
      submenu: [
        {
          title: '2024年04月',
          url: '/2404/anime',
        },
        {
          title: '2024年01月',
          url: '/2401/anime',
        },
        {
          title: '2023年10月',
          url: '/2310/anime',
        },
        {
          title: '2023年7月',
          url: '/2307/anime',
        },
      ],
    },
    {
      title: '実写化シリーズ',
      submenu: [
        {
          title: '2024年04月',
          url: '/2404/live-action',
        },
        {
          title: '2024年01月',
          url: '/2401/live-action',
        },
        {
          title: '2023年10月',
          url: '/2310/live-action',
        },
        {
          title: '2023年7月',
          url: '/2307/live-action',
        },
      ],
    },
  ];